export const getApiBaseUrl = (): string => {
  // return process.env.REACT_APP_API_BASE_URL || 'https://beta.portal.hciindia.in/api';
  return process.env.REACT_APP_API_BASE_URL || 'http://localhost/hci/api';

};